import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { keycloak } from './keycloak';
import type { RootState } from '../store';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: fetchBaseQuery({
    baseUrl:
      import.meta.env.VITE_PAYMENT_API_URL ||
      'http://localhost:7013/api/v1/payments',
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const orgId = state.org?.selectedOrgId;

      if (orgId) {
        headers.set('X-Tenant-Id', orgId);
      }

      if (keycloak.authenticated && keycloak.token) {
        headers.set('Authorization', `Bearer ${keycloak.token}`);
      }
      return headers;
    },
  }),
  endpoints: builder => ({
    capturePayment: builder.mutation<
      void,
      {
        razorpay_payment_id: string;
        razorpay_order_id: string;
        razorpay_signature: string;
      }
    >({
      query: payload => ({
        url: '/capture',
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const { useCapturePaymentMutation } = paymentApi;
